import { Greeting } from '../../data/cms';
import { useCms, CmsStatus, HtmlContent, imageUrl } from './Cms';
import Reveal from './Reveal';
export default function GreetingSection() {
  const { data, loading, error, retry } = useCms<Greeting>('/greeting-item');
  return <section className="cms-greeting">
    {loading || error || !data ? <CmsStatus loading={loading} error={error} retry={retry} empty="代表挨拶は現在準備中です。" /> : <>
      <Reveal className="company-profile"><div>{imageUrl(data.image?.url) && <img src={imageUrl(data.image?.url)} alt={data.image?.alternativeText || data.name || '代表写真'} className="profile-photo" loading="lazy" />}<h2 className="profile-name"><small>{data.position}</small>{data.name}</h2></div><div><h2 className="content-heading" style={{ marginBottom: 25 }}>代表の経歴</h2>{data.personal_history && <HtmlContent html={data.personal_history} />}</div></Reveal>
      <Reveal className="detail-section"><h2 className="content-heading" style={{ marginBottom: 25 }}>代表挨拶</h2>{data.description && <HtmlContent html={data.description} />}</Reveal>
    </>}
  </section>;
}
